var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M714-178 531-361l68-68 183 183q14 14 14 34t-14 34q-14 14-34 14t-34-14Zm-536 0q-14-14-14-34t14-34l234-234-64-64-13 13q-11 11-25 11t-25-11l-27-27v79q0 12-11.5 16t-19.5-4L125-569q-8-8-4-19.5t16-11.5h79l-11-12q-11-11-11-25t11-25l119-119q17-17 38.5-26t45.5-9q19 0 35.5 5.5T475-794q7 5 7.5 13.5T477-766l-72 71 22 22q11 11 11 25t-11 25l-11 11 64 64 83-83q-5-13-8-26t-3-27q0-55 38.5-93.5T684-816q7 0 13.5.5T711-813q9 3 11.5 11.5T718-786l-55 55q-5 5-5 13t5 13l42 42q5 5 13 5t13-5l55-55q7-7 15.5-4.5T813-711q2 7 2.5 13.5t.5 13.5q0 55-38.5 93T684-553q-14 0-27-2.5t-26-8.5L246-178q-14 14-34 14t-34-14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.0de6dff6fe0ea66379965e25fb88dcee.svg";
export { ForwardRef as ReactComponent };